// extracted by mini-css-extract-plugin
module.exports = {"review_container":"StoreReviewList_review_container__Yfd_J","review_pagination":"StoreReviewList_review_pagination__LouQh"};